import React, { Component } from 'react';
import styled from 'styled-components';
import Icon from '../../DocumentView/components/Icon';
import { DownloadPDFButton } from '../../Icons';
const Styled = styled.div `
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  width: 100%;
  height: 40px;
  max-width: 420px;
  background-color: rgba(83, 85, 92, 0.8);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  font-size: ${(props) => props.theme.fontXXSmall};
  z-index: 999;
`;
const IcoContainer = styled.div `
  display: flex;
  ${(props) => props.disabled && `opacity: 0`};
`;
class Buttons extends Component {
    render() {
        const { numPages, handleScrollClick, handleScaleClick, currentPage, responsiveScale, completed, isEnterprise, downloadUrl, } = this.props;
        const canShowCompletedForEnterprise = isEnterprise && completed && downloadUrl;
        return (React.createElement(Styled, null,
            React.createElement(IcoContainer, { onClick: () => handleScaleClick('MINUS'), disabled: responsiveScale === 1 },
                React.createElement(Icon, { name: "icon-zoom-out" })),
            React.createElement(IcoContainer, { onClick: () => handleScrollClick(currentPage - 1), disabled: currentPage <= 1 },
                React.createElement(Icon, { name: "icon-up" })),
            currentPage,
            " z ",
            numPages,
            React.createElement(IcoContainer, { onClick: () => handleScrollClick(currentPage + 1), disabled: currentPage === numPages },
                React.createElement(Icon, { name: "icon-down" })),
            React.createElement(IcoContainer, { onClick: () => handleScaleClick('PLUS') },
                React.createElement(Icon, { name: "icon-zoom-in" })),
            canShowCompletedForEnterprise && (React.createElement("a", { href: downloadUrl, download: true },
                React.createElement(DownloadPDFButton, null)))));
    }
}
export default Buttons;
